// Aux function to convert a camelCase string to snake_case
const camelToSnake = key => {
  const result = key.replace(/([A-Z])/g, ' $1');
  return result.split(' ').join('_').toLowerCase();
};
const snakeToCamel = key => key.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
class OwnContractCredentialsMapper {
  /**
   * @param credentials Contract credentials (camelCase)
   * @return api credentials (snake_case)
   */
  static createOwnContractCredentialsApiParams(credentials) {
    return Object.keys(credentials).reduce((acc, key) => {
      const newKey = camelToSnake(key);
      return {
        ...acc,
        [newKey]: credentials[key]
      };
    }, {});
  }
  static createModelFromResponse(credentials) {
    return Object.keys(credentials).reduce((acc, key) => {
      const newKey = snakeToCamel(key);
      return {
        ...acc,
        [newKey]: credentials[key]
      };
    }, {});
  }
}

export { OwnContractCredentialsMapper };
//# sourceMappingURL=OwnContractCredentialsMapper.js.map
